require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-first-cu-president-receives-chairmans-award-from-the.json") })
        }
      }, "path---articles-financial-center-first-cu-president-receives-chairmans-award-from-the");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-first-cu-president-receives-chairmans-award-from-the!./.cache/json/articles-financial-center-first-cu-president-receives-chairmans-award-from-the.json
// module id = 1631
// module chunks = 231608221292675